import { Injectable } from "@angular/core";
import { GenericService } from "./generic.service";
import { environment } from "src/environments/environment";
import { ISAPI } from "is-lib";
import { ServerResponse } from "../models/ServerResponse";
import { Observable } from "rxjs";
import { UsersService } from "./users.service";

@Injectable({
    providedIn: 'root'
})

export class AddressesService{
    constructor(private _httpService: GenericService, private _userService: UsersService) { }
    
    getDistricts(): Observable<ServerResponse<any>>{
        return this._httpService.get(`${environment.apiUrl}Addresses/${this._userService.userCountryCode}/Districts`, undefined, true);
    }

    getPostalCodePT(zipCode: string, callLoader: boolean = true) {
        return this._httpService.get<any>(`${environment.apiUrl}Addresses/PT/FullPostalCode/${zipCode}`, undefined, true);
    }

    getPostalCodeES(zipCode: string, callLoader: boolean = true) {
        return this._httpService.get<any>(`${environment.apiUrl}Addresses/ES/FullPostalCode/${zipCode}/AddressHierarchy`, undefined, true);
    }

    getParishes(countyId: number, callLoader: boolean = true) {
        return this._httpService.get<any>(`${environment.apiUrl}Addresses/${(this._userService.userCountryCode == undefined ? localStorage.getItem('lang') : this._userService.userCountryCode)}/Counties/${countyId}/Parishes`, undefined, true);
    }
}